import { render, staticRenderFns } from "./ShortlistingPanel.vue?vue&type=template&id=ebba8574&scoped=true&"
import script from "./ShortlistingPanel.vue?vue&type=script&lang=js&"
export * from "./ShortlistingPanel.vue?vue&type=script&lang=js&"
import style0 from "./ShortlistingPanel.vue?vue&type=style&index=0&id=ebba8574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebba8574",
  null
  
)

export default component.exports